import WillLearn from './WillLearn'

export default WillLearn
